import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import BlogItem from 'flarum/v17development/blog/pages/BlogItem';

export default function () {
	if (app.initializers.has('v17development-flarum-blog')) {
		extend(BlogItem.prototype, 'contentItems', function (items) {
			items.remove('image');
		});
	}
}
